import DraggableList from './draggable-list'
import {
  FIELD_PROPS,
  INNER_FIELD_PROPS,
  COLUMN_WIDTHS
} from '../constants'

const FieldRow = {
  components: { DraggableList },
  props: {
    row: {
      type: Object,
      default: () => ({})
    },
    rowIndex: {
      type: Number,
      default: 0
    },
    level: {
      type: Number,
      default: 0
    },
    activeKey: {
      type: String,
      default: ''
    },
    totalRows: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {}
  },
  computed: {
    hasChildren() {
      return this.row[INNER_FIELD_PROPS.CHILD] && this.row[INNER_FIELD_PROPS.CHILD].length > 0
    },
    checkboxValue() {
      return this.row[INNER_FIELD_PROPS.SHOW]
    },
    checkboxIndeterminate() {
      return this.row[INNER_FIELD_PROPS.INDTERMINATE]
    },
    fiexdValue() {
      return this.row[INNER_FIELD_PROPS.FIXED]
    }
  },
  methods: {
    handleShowChange(val) {
      this.$emit('showChange', val, this.row)
    },
    handleChildShowChange(val, row) {
      this.$emit('showChange', val, row)
    },
    handleLabelClick() {
      const show = this.checkboxValue
      this.$emit('showChange', !show, this.row)
    },
    handleFixedChange(val) {
      this.$emit('fixedChange', val, this.row)
    },
    handleMoveInput(val) {
      const numVal = val.replace(/[^\d]/g, '')
      if (!numVal) return

      let targetIndex = parseInt(numVal, 10)
      const maxIndex = this.totalRows

      if (maxIndex > 0 && targetIndex > maxIndex) {
        targetIndex = maxIndex
      }

      if (this.$refs.moveInput) {
        this.$refs.moveInput.currentValue = ''
      }

      this.$emit('move', targetIndex, this.row)
    },
    handleMoveKeypress(e) {
      if (!/[\d]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'Tab') {
        e.preventDefault()
      }
    }
  },
  render() {
    const { row, rowIndex, level, hasChildren, checkboxValue, checkboxIndeterminate, fiexdValue, activeKey } = this
    const isActive = activeKey === row[FIELD_PROPS.KEY]
    const wrapClass = `kye-field-settings-row-wrap ${hasChildren ? 'has-child' : ''}`
    const rowClass = `kye-field-settings-row ${isActive ? 'is-active' : ''}`
    const childClass = 'kye-field-settings-row-child'
    const renderCheckbox = () => {
      return (
        <div class="kye-field-settings-row-cell is-check" style={{ width: COLUMN_WIDTHS.CHECK, paddingLeft: level * 14 + 'px' }}>
          <el-checkbox
            value={checkboxValue}
            indeterminate={checkboxIndeterminate}
            onInput={this.handleShowChange}
          />
        </div>
      )
    }
    const renderLabel = () => {
      const label = row[FIELD_PROPS.LABEL]
      const displayLabel = level === 0 ? `${rowIndex + 1}. ${label}` : label
      return <div class="kye-field-settings-row-cell is-label" style={{ paddingLeft: level * 10 + 'px' }} onClick={this.handleLabelClick}>{displayLabel}</div>
    }
    const renderFixed = () => {
      if (level !== 0) return null
      return (
        <div class="kye-field-settings-row-cell is-fixed" style={{ width: COLUMN_WIDTHS.FIXED }}>
          <el-checkbox
            value={fiexdValue}
            onInput={this.handleFixedChange}
          />
        </div>
      )
    }
    const renderMoveInput = () => {
      if (level !== 0) return null
      return (
        <div class="kye-field-settings-row-cell is-move" style={{ width: COLUMN_WIDTHS.MOVE }}>
          <el-input
            ref="moveInput"
            size="mini"
            type="number"
            nativeOnKeypress={this.handleMoveKeypress}
            onBlur={e => this.handleMoveInput(e.target.value)}
          />
        </div>
      )
    }

    return (
      <div class={wrapClass}>
        <div class={rowClass}>
          {renderCheckbox(level)}
          {renderLabel()}
          {renderFixed()}
          {renderMoveInput()}
        </div>
        {/* 子级字段 */}
        {hasChildren && (
          <DraggableList
            class={childClass}
            fields={row[INNER_FIELD_PROPS.CHILD]}
            level={level + 1}
            activeKey={activeKey}
            onShowChange={this.handleChildShowChange}
          />
        )}
      </div>
    )
  }
}

export default FieldRow



// WEBPACK FOOTER //
// ./src/public/components/kye-field-settings/components/field-row.js